/**
 *
 */
import * as bootstrap from 'bootstrap';
import setupCommunityFinder from './app/community-finder';
import setupSearchForms from './app/search';
import setupFaqs from './app/faqs';
import setupTextSizeControls from './app/text-size-controls';
import setupAnimateOnScroll from './app/animate-on-scroll';
import setupCommunityMaps from './app/communities/map';
import setupCommunityGalleries from './app/communities/gallery';
import setupCommunityVirtualTours from './app/communities/virtual-tour';
import setupCommunityForms from './app/communities/forms';
import setupVirtualTourViewer from './app/virtual-tour-viewer';
import setupCommunityTracking from './app/communities/tracking';
import setupSiteNotices from './app/site-notices';
// import {showScreenInfo} from './app/dev';

/**
 *
 */
window.addEventListener( 'DOMContentLoaded', () =>
{
	const body = document.querySelector( 'body' );

	if (body instanceof Element) {
		body.classList.add( 'loaded' );
	}

	setupCommunityFinder();
	setupSearchForms();
	setupFaqs();
	setupTextSizeControls();
	setupAnimateOnScroll();
	setupCommunityMaps();
	setupCommunityGalleries();
	setupCommunityVirtualTours();
	setupCommunityForms();
	setupVirtualTourViewer();
	setupCommunityTracking();
	setupSiteNotices();

	//showScreenInfo();
} );